import { render, staticRenderFns } from "./StudentAutoComplete.vue?vue&type=template&id=5033874a&"
import script from "./StudentAutoComplete.vue?vue&type=script&lang=js&"
export * from "./StudentAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports